export default __webpack_public_path__ + "static/media/10.673ed790.jpg";